export default __webpack_public_path__ + "static/media/Aadhya.a67092ab.jpg";